export default __webpack_public_path__ + "static/media/order-reopen.b4a94807.svg";